import { Box, Button, Flex, FormControl, FormLabel, Image, Spinner, Text, Textarea, useToast } from '@chakra-ui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { MdDelete } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const About = () => {
    const navigate = useNavigate();
    const toast = useToast();
    let url = process.env.REACT_APP_DEV_URL;
  const [dataUrl, setDataUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [image, setImage] = useState({});

    const [detail, setDetail] = useState({
        about_detail: "",
      description: "",
      image:""
    });

    const handleChange = (e) => {
    const { name, value } = e.target;
    setDetail({ ...detail, [name]: value });
    };

  
    const editAbout = async (imageUrl) => {
      debugger
      let dup={...detail}
      if(imageUrl){
        dup.image=imageUrl
      }
      try {
        let data = await fetch(`${url}/about/edit/${detail._id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dup),
        });
        data = await data.json();
        console.log(data);
        toast({
          title: "About Page Edited",
          description: data.msg,
          status: "success",
          position: "top",
          duration: 9000,
          isClosable: true,
        });
        navigate("/admin/page");
      } catch (error) {
        toast({
          title: "Error In Uploading Updates",
          description: error.message,
          status: "error",
          position: "top",
          duration: 9000,
          isClosable: true,
        });
      }
    };
  
    const handleImage = (index) => {
      // let dup=[...product.image]
      //  dup.splice(index, 1);
      setDetail({ ...detail, image: "" });
    };
  
    const handleImageLocal = (index) => {
      setDataUrl("");
    };
  
    const handleFileChanger = (e) => {
      let file = e.target.files[0];
      console.log(file);
      // setImage(file);
      setImage(file);
      if (file) {
        let reader = new FileReader();
        reader.onloadend = () => {
          // setDataUrl(reader.result);
  
          setDataUrl(reader.result);
        };
        reader.readAsDataURL(file);
      }
    };

    const formData = new FormData();
    const submitFile = async () => {

      if (dataUrl === "") {
        return;
      }
  
      formData.append("about", image);
  
      setIsLoading(true);
      try {
        let data = await axios.post(`${url}/about/image`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log(data.data.data);
        return data.data.data;
      } catch (error) {
        console.log(error);
      }
    };
    const getAbout = async () => {
      try {
        let data = await fetch(`${url}/about`);
        data = await data.json();
        console.log(data.data[0]);
        setDetail(data.data[0]);
      } catch (error) {
        console.log(error);
      }
    };
    useEffect(() => {
    getAbout();
    }, []);
  return (
    <Box p="4">
        <div>
      <Box
        backgroundColor={"white"}
        boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
        padding={"20px"}
        borderRadius={"20px"}
      >
         <FormControl isRequired>
            <FormLabel color={"#f9a526"}>Banner Image</FormLabel>
            {dataUrl && (
              <>
                <Flex gap="20px">
                  <Image src={dataUrl} />
                  <MdDelete
                    color="red"
                    size={"30px"}
                    onClick={() => handleImageLocal()}
                  />
                </Flex>
              </>
            )}
          
            {detail?.image && (
              <Flex gap="20px">
                <Image  src={`${url}/about/${detail?.image}`} />
                <Box _hover={{ cursor: "pointer" }}>
                  <MdDelete
                    color="red"
                    size={"30px"}
                    onClick={() => handleImage()}
                  />
                </Box>
              </Flex>
            )}
            <br />
            <form encType="multipart/form-data">
              <input
                required
                type="file"
                name="about"
                onChange={(e) => handleFileChanger(e)}
              />
            </form>
            
          </FormControl>
        <FormControl>
          <FormLabel color={"#f9a526"}>About Us</FormLabel>
          <Textarea
            value={detail?.about_detail}
            name="about_detail"
            onChange={(e) => handleChange(e)}
          />
        </FormControl>
        <br />
        <FormControl>
          <FormLabel color={"#f9a526"}>Description</FormLabel>
          <Textarea
            value={detail?.description}
            name="description"
            onChange={(e) => handleChange(e)}
          />
        </FormControl>
        <br />
        <Box>
          <Button
            variant={"solid"}
            bgColor={"black"}
          leftIcon={isLoading && <Spinner color="blue.500" />}
            color="#f9a526"
            _hover={{
            color: "black",
            bgColor: "#f9a526",
            border: "1px solid #f9a526",
            }}
            onClick={() => 
              Promise.all([submitFile()])
              .then((result) =>setTimeout(()=>editAbout(result[0]),2000)
               )
              .catch((err) => console.log(err))
            }
            
          >
            Save About
          </Button>
        </Box>
      </Box>
    </div>
    </Box>
  )
}

export default About